import React from "react";
import { Button, Card } from "react-bootstrap";
import "./HomeProjectCard.css";

const HomeProjectCard = (props) => {
  const {
    title,
    description,
    technology,
    img_1,
    img_2,
    img_3,
    liveSite,
    clientGithub,
    serverGithub,
  } = props.project;
  const sortDescription = description.slice(0, 150);
  return (
    <div className="col-md-4 p-3">
      <Card className="homeProjectCard">
        <Card.Img src={img_1} alt="" />
        <Card.Body>
          <Card.Title className="text-dark">{title}</Card.Title>
          <Card.Text className="text-muted">
            <small>{sortDescription}.....</small>
          </Card.Text>
          {/* <Card.Footer> */}
          <div className="d-flex justify-content-around">
            <a target="_blank" href={liveSite}>
              <Button className="btn-success">Live Site</Button>
            </a>
            {clientGithub && (
              <a target="_blank" href={clientGithub}>
                <Button className="btn-secondary">GitHub</Button>
              </a>
            )}
          </div>
          {/* </Card.Footer> */}
        </Card.Body>
      </Card>
    </div>
  );
};

export default HomeProjectCard;
